import React, { useEffect, useState } from "react";

import { Button, Modal, Tabs, Tab } from "react-bootstrap";
import { getAllGateways, setSelectedGateway } from "../../redux/user/actions";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import DepositImg from "../../assets/images/icons/dc.png";
import bankImg from "../../assets/images/icons/bank.png";
import RightArrow from "../../assets/images/icons/right-chevron.png";
import { getActiveBankDetails } from "../../redux/app/actions";
import DepositGatewayModal from "./DepositGatewayModal";

const DepositModal = ({
  changeContent,
  setChangeContent,
  showDepositModal,
  setShowDepositModal,
}) => {
  const dispatch = useDispatch();
  // const [changeContent, setChangeContent] = useState(false);
  const { gatewaysList } = useSelector((state) => state.user);
  const { bankDetails } = useSelector((state) => state.app);
  const isAutoGatewayExist = gatewaysList?.deposits?.some(
    (f) => f?.type === "auto"
  );
  // const [showDepositModal, setShowDepositModal] = useState(false);

  const [gateway, setGateway] = useState("");

  const handleClose = () => {
    setShowDepositModal(false);
  };

  const handleShow = (e) => {
    e.preventDefault();
    setShowDepositModal(true);
    setChangeContent(false);
  };

  useEffect(() => {
    dispatch(getAllGateways());
    dispatch(getActiveBankDetails());
  }, []);

  const handleGatewayClick = (item) => {
    // dispatch(setSelectedGateway(item));
    setChangeContent(true);
    setGateway(item?.id);
  };

  const handleBankTransferClick = () => {
    setGateway("bank_transfer");
    setChangeContent(true);
  };

  return (
    <>
      <div className="dpst-btn">
        <Button variant="" onClick={handleShow}>
          Deposit
        </Button>
      </div>

      <Modal
        show={showDepositModal}
        onHide={handleClose}
        centered
        className="deposit-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Deposit</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            {!changeContent ? (
              <main className="main">
                <div className="container">
                  <div className="gatewaySection mt-4">
                    <div className="gatewaypart">
                      <Tabs
                        defaultActiveKey={isAutoGatewayExist ? "bank" : "bank"}
                        id="uncontrolled-tab-example"
                      >
                        <Tab eventKey="bank" title="Bank Deposit">
                          {bankDetails && (
                            <div
                              className="cards1"
                              onClick={() => handleBankTransferClick()}
                            >
                              <div className="card-icon">
                                <img src={bankImg} />
                              </div>
                              <p style={{ color: "#fff" }}>{"Bank Transfer"}</p>
                              <img
                                src={RightArrow}
                                alt="arrow"
                                className="arrow"
                              />
                            </div>
                          )}
                        </Tab>

                        <Tab eventKey="upi" title="ONLINE">
                          {gatewaysList?.deposits
                            ?.sort((a, b) => a?.order - b?.order)
                            ?.filter((f) => f?.type === "auto")
                            .map((item, index) => {
                              return (
                                <div
                                  className="cards1"
                                  onClick={() => {
                                    handleGatewayClick(item);
                                  }}
                                  key={index}
                                >
                                  <div className="card-icon">
                                    <img src={item?.logo || DepositImg} />
                                  </div>
                                  <p style={{ color: "#fff" }}>{item?.name}</p>
                                  <img
                                    src={RightArrow}
                                    alt="arrow"
                                    className="arrow"
                                  />
                                </div>
                              );
                            })}
                        </Tab>

                        <Tab eventKey="Deposit" title="Manual">
                          {gatewaysList?.deposits
                            ?.sort((a, b) => a?.order - b?.order)
                            ?.filter((f) => f?.type === "manual")
                            .map((item, index) => {
                              return (
                                <div
                                  className="cards1"
                                  onClick={() => {
                                    handleGatewayClick(item);
                                  }}
                                  key={index}
                                >
                                  <div className="card-icon">
                                    <img src={item?.logo || DepositImg} />
                                  </div>

                                  <p style={{ color: "#fff" }}>{item?.name}</p>
                                  <img
                                    src={RightArrow}
                                    alt="arrow"
                                    className="arrow"
                                  />
                                </div>
                              );
                            })}
                        </Tab>
                      </Tabs>
                    </div>
                  </div>
                </div>
              </main>
            ) : (
              <DepositGatewayModal
                setChangeContent={setChangeContent}
                gateway={gateway}
                setGateway={setGateway}
              />
            )}
          </>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DepositModal;
